import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Condominio, Grupo, SearchResultGeneral } from '../interfaces/condominio';
import { Notificacao } from '../interfaces/notificacao';
import { Unidade } from '../interfaces/unidade';

@Injectable({
  providedIn: 'root',
})
export class CondominioService {
  private identidade = environment.api.identidade;

  constructor(private http: HttpClient) { }

  getCondominios() {
    return this.http.get<Array<any>>(`condominio`).pipe();
  }

  getCondominiosAntigos() {
    return this.http
      .post('https://www.condominioapp.com/mobile/api/usuario/LoginWeb', {
        email: 'administrador@condominioapp.com',
        senha: 'techapp@2020!',
      })
      .toPromise();
  }

  getCondominioId(condominioID) {
    return this.http.get<any>(`condominio/${condominioID}`).toPromise();
  }

  pegarQuantidadesNaoLidasADM(usuarioId: string) {
    return this.http.get(`notificacao/obter-quantidade-nao-lida-por-administrador/${usuarioId}`).pipe();
  }

  marcarNotificacaoComoLida(notificacaoId: string) {
    return this.http.put(`notificacao/marcar-como-lida/${notificacaoId}`, {}).pipe();
  }

  pegarNotificacoesADM(usuarioId: string): Observable<Notificacao[]> {
    return this.http.get<Notificacao[]>(`notificacao/obter-por-administrador/${usuarioId}`).pipe();
  }

  pegarNotificacoesPorDestinatarioETipo(destinatarioId: string, tipo) {
    return this.http.get(`notificacao/obter-por-destinatario-e-tipo/${destinatarioId}/${tipo}`).pipe();
  }

  criarSindicoDoCondominio(form) {
    return this.http
      .post(`${this.identidade}nova-conta-funcionario`, form)
      .toPromise();
  }

  pegarTemplateImportarMoradores(condominioId) {
    return this.http
      .get(`morador/template-importar-moradores?condominioId=${condominioId}`, {
        observe: 'response',
        responseType: 'blob',
      })
      .pipe();
  }

  pegarTemplateImportarVeiculos(condominioId) {
    return this.http
      .get(`veiculo/template-importar-veiculos?condominioId=${condominioId}`, {
        observe: 'response',
        responseType: 'blob',
      })
      .toPromise();
  }

  importarMoradoresExcel(formData) {
    return this.http.post(`morador/importar-moradores`, formData).toPromise();
  }

  importarVeiculosExcel(formData) {
    return this.http.post(`veiculo/importar-veiculos`, formData).toPromise();
  }

  updateMoradorImportacao(form) {
    return this.http.put(`morador/morador-mailing`, form).toPromise();
  }

  criarMoradorImportacao(form) {
    return this.http.post(`morador/morador-mailing`, form).toPromise();
  }

  registrarNovasContasDeMoradores(form) {
    return this.http
      .post(`${this.identidade}registrar-novas-contas-de-moradores`, form)
      .toPromise();
  }

  enviarMailing(form) {
    return this.http
      .put(`${this.identidade}mailing/${form.condominioId}`, form)
      .toPromise();
  }

  excluirMoradorImportacao(moradorId) {
    return this.http
      .delete(`morador/apagar-morador-mailing/${moradorId}`)
      .toPromise();
  }

  excluirMoradoresImportacao(condominioId) {
    return this.http
      .delete(
        `morador/apagar-todos-moradores-mailing-condominio/${condominioId}`
      )
      .toPromise();
  }

  listarMoradoresImportados(condominioId) {
    return this.http.get(`morador/mailing/${condominioId}`).toPromise();
  }

  adicionarCondominio(form) {
    return this.http.post(`condominio`, form).toPromise();
  }

  editarLogoDoCondominio(form) {
    return this.http.put(`condominio/logo`, form).toPromise();
  }

  editarCondominio(form) {
    return this.http.put(`condominio`, form).toPromise();
  }

  atualizarFuncionalidades(form) {
    return this.http.put(`condominio/configuracao`, form).toPromise();
  }

  listarContratos(condominioId) {
    return this.http.get(`contrato/por-condominio/${condominioId}`).pipe();
  }

  relatorioUnidadesExcel(condominioId) {
    return this.http
      .get(`condominio/unidades-em-excel?condominioId=${condominioId}`, {
        observe: 'response',
        responseType: 'blob',
      })
      .pipe();
  }

  definirSindico(funcionarioId) {
    return this.http
      .put(`condominio/definir-sindico/${funcionarioId}`, '')
      .toPromise();
  }

  listarFuncionarios(condoinioId) {
    return this.http
      .get(`funcionario/por-condominio/${condoinioId}`)
      .toPromise();
  }

  adicionarContrato(form) {
    return this.http.post(`contrato`, form).pipe();
  }

  excluirContrato(contratoId) {
    return this.http.delete(`contrato/${contratoId}`).pipe();
  }

  editarContrato(form) {
    return this.http.put(`contrato`, form).pipe();
  }

  ativarCondominio(condominioId) {
    return this.http.put(`contrato/ativar/${condominioId}`, '').pipe();
  }

  desativarCondominio(condominioId) {
    return this.http.put(`contrato/desativar/${condominioId}`, '').pipe();
  }

  adicionarGrupo(grupo) {
    return this.http.post(`grupo`, grupo).pipe();
  }

  editarGrupo(grupo) {
    return this.http.put<any>(`grupo`, grupo).toPromise();
  }

  editarGrupoCep(grupoCep) {
    return this.http.put<any>(`grupo/cep`, grupoCep).toPromise();
  }

  getUnidadesPorGrupo(grupoId: string): Observable<Unidade[]> {
    return this.http.get<Unidade[]>(`unidade/por-grupo/${grupoId}`).pipe();
  }

  adicionarUnidadeAoGrupo(unidade) {
    return this.http.post(`unidade`, unidade).toPromise();
  }

 // unidade.service.ts

  adicionarUnidadeIndividualAoGrupo(unidade: any): Promise<any> {
      return this.http.post(`unidade/individual`, unidade).toPromise();
  }

  editarUnidadeDoGrupo(unidade) {
    return this.http.put(`unidade`, unidade).toPromise();
  }

  deletarGrupo(id) {
    return this.http.delete(`grupo/${id}`).toPromise();
  }

  atualizarCodigoDaUnidade(id, form?) {
    return this.http.put(`unidade/atualizar-codigo/${id}`, form).toPromise();
  }

  deletarUnidade(id) {
    return this.http.delete(`unidade/${id}`).toPromise();
  }

  getGruposPorCondominio(condominioId): Observable<Grupo[]> {
    return this.http.get<Grupo[]>(`grupo/por-condominio/${condominioId}`).pipe();
  }

  enviarPushPersonalizadoCondominios(form) { }

  vincularCondominiosAoUsuario(form) {
    return this.http
      .post(`funcionario/vincular-funcionario-condominio`, form)
      .toPromise();
  }

  desvincularCondominioDoUsuario(funcionarioId: string) {
    return this.http.delete(`funcionario/${funcionarioId}`).toPromise();
  }

  atualizarUrlDaAdministradoraDoCondominio(form: object) {
    return this.http.put(`condominio/dados-boleto`, form).pipe();
  }

  listarUsuariosDesativadosPorCondominio(condominioId: string) {
    return this.http.get(`morador/desativados-por-condominio/${condominioId}`).pipe();
  }


  searchGeneral(term: string): Observable<SearchResultGeneral[]> {
    return this.http.get<SearchResultGeneral[]>(`condominio/busca-geral-adm/${term}`).pipe();
  }

  mapaDeCalorPorCondominio(usuarioId: string, condominioId: string) {
    return this.http.get(`mapadecalor/${usuarioId}/${condominioId}`).pipe();
  }

  mapaDeCalorPorUnidade(usuarioId: string, condominioId: string) {
    return this.http.get(`mapadecalor/por-unidade/${usuarioId}/${condominioId}`).pipe();
  }

  mapaDeCalorPorUltimoLoginMorador(usuarioId: string, condominioId: string) {
    return this.http.get(`mapadecalor/moradores/${usuarioId}/${condominioId}`).pipe();
  }

  mapaDeCalor(usuarioId: string) {
    return this.http.get(`mapadecalor/${usuarioId}`).pipe();
  }

  mapaDeCalorListar() {
    return this.http.get<any>(`mapadecalor/listar-relatorios`).pipe();
  }


  // Reconhecimento facial
  obterDispositivosDoCondominio(condominioId: string) {
    return this.http.get<any>(`controlId/dispositivos/obter-por-condominio/${condominioId}`).pipe();
  }

  obterDispositivoPorId(dispositivoId: string) {
    return this.http.delete(`controlId/dispositivos/${dispositivoId}`).pipe();
  }

  cadastrarDispositivosDoCondominio(form) {
    return this.http.post(`controlId/dispositivos`, form).pipe();
  }

  removerDispositivoDoCondominio(dispositivoId: string) {
    return this.http.delete(`controlId/dispositivos/${dispositivoId}`).pipe();
  }

  obterAreasComunsPorCondominio(condominioId: string) {
    return this.http.get<any>(`areacomum/por-condominio/${condominioId}`).pipe();
  }

  obterblocosPorCondominio(condoinioId: string) {
    return this.http.get<any>(`grupo/por-condominio/${condoinioId}`).pipe();
  }

}

